export function formatBalance(value: string | number, maxDecimals = 8): string {
	const numericValue = typeof value === 'string' ? Number.parseFloat(value) : value

	if (!Number.isFinite(numericValue)) {
		return '0'
	}

	return numericValue.toLocaleString('en-US', {
		maximumFractionDigits: maxDecimals,
		minimumFractionDigits: 0,
	})
}

export function formatBalanceMeta(
	value: string | number,
	maxDecimals = 8,
): {
	value: number
	formatted: string
	decimalPlaces: number
} {
	const numericValue = typeof value === 'string' ? Number.parseFloat(value) : value
	const safeValue = Number.isFinite(numericValue) ? numericValue : 0
	const formatted = formatBalance(safeValue, maxDecimals)
	const [, fraction = ''] = formatted.split('.')

	return {
		value: safeValue,
		formatted,
		decimalPlaces: fraction.length,
	}
}

export function formatAmount(value: string | number, maxDecimals = 2): string {
	const numericValue = typeof value === 'string' ? Number.parseFloat(value) : value

	if (!Number.isFinite(numericValue)) {
		return '0'
	}

	return numericValue
		.toLocaleString('en-US', {
			maximumFractionDigits: maxDecimals,
			minimumFractionDigits: 0,
		})
		.replace(/,/g, ' ')
}

export function formatPercent(value: number): string {
	if (!Number.isFinite(value)) {
		return '0%'
	}

	return `${value.toFixed(2)}%`
}

export function formatSignedAmount(value: string | number, maxDecimals = 8): string {
	const numericValue = typeof value === 'string' ? Number.parseFloat(value) : value

	if (!Number.isFinite(numericValue)) {
		return '0'
	}

	const formattedValue = formatBalance(Math.abs(numericValue), maxDecimals)

	if (numericValue > 0) {
		return `+${formattedValue}`
	}

	if (numericValue < 0) {
		return `-${formattedValue}`
	}

	return formattedValue
}

export function splitFormattedCurrency(value: string): { main: string; decimals: string } {
	const normalized = value.replace(/,/g, '')
	const [integerPart = '0', decimalPart = ''] = normalized.split('.')
	const main = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

	return {
		main,
		decimals: decimalPart ? `.${decimalPart}` : '',
	}
}
